module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_fondo_foto.e9c8ffa9.png";